export default class Contact {
    constructor() {
        this.file = document.querySelectorAll('.file__label');

        this.file.forEach((el) => {
            const input = el.querySelector('input')
            input.addEventListener('change', (e) => {
                const name = e.currentTarget.files[0].name;
                el.setAttribute('data-file', name)
            })
        })
    }

}